import { KngFooterCopyRightLabel, KngFooterMenu, KngFooterState } from './definitions/footer.interface';

export class KngFooterFactory
{
	public static buildState(): KngFooterState
	{
		return {
			ribbonImage: '',
			altText: '',
			cssClass: '',
			footercontent: {
				css: {
					ecomm: ''
				},
				script: {},
				unifiedFooter: '',
				fixed: false,
				hidden: false,
				logoImagePath: '',
				altText: '',
				footermenu: this.getFooterMenu(),
				copyright: {
					label: '',
					labelUrl: this.getLabelUrl()
				}
			}
		};
	}
	public static getLabelUrl(): KngFooterCopyRightLabel[]
	{
		const obj: KngFooterCopyRightLabel[] = [];
		for(let i = 0; i<4 ; i++)
		{
			obj.push({ label: '', url: '' });
		}
		return obj;
	}
	public static getFooterMenu(): KngFooterMenu[]
	{
		const footerObj: KngFooterMenu[] = [];
		for(let i = 0; i<4 ; i++)
		{
			footerObj.push({ id: '',	label: '', iconPath: '', altText: '', labelValue: [], url: '' });
		}
		return footerObj;
	}
}
